module.exports = __webpack_public_path__ + "static/media/star.eb7f0d1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/DubfShowcaseBrowser/star.svg
// module id = 199
// module chunks = 0